module.exports = __webpack_public_path__ + "img/Skirt-Front-B5-Da-Ge-Ha-Ib-Jb.9dd9feff.png";